<template>
  <el-card>
    <template #header>
      <content-header />
    </template>
    <el-row type="flex" justify="left">
      <lz-form ref="form" :get-data="getData" :submit="onSubmit" :form.sync="form" :errors.sync="errors" :edit-mode="editMode" >

        <el-form-item label="标识" required prop="slug">
          <el-input v-model="form.slug" />
        </el-form-item>

        <el-form-item label="名称" required prop="name">
          <el-input v-model="form.name" />
        </el-form-item>

        <el-form-item label="权限" required prop="permissions">
          <el-checkbox @change=selectAllOrCancel v-model="checked">全选/取消</el-checkbox>
        <el-tree
          :data="permissionsList"
          show-checkbox
          :check-strictly="isCheck"
          node-key="id"
          ref="tree"
          highlight-current
          :props="defaultProps">
        </el-tree>
        </el-form-item>

      </lz-form>
    </el-row>

  </el-card>
</template>

<script>
  import LzForm from '@c/LzForm'
  import {createAdminRole, editAdminRole, storeAdminRole, updateAdminRole} from '@/api/admin-roles'
  import FormHelper from '@c/LzForm/FormHelper'

  export default {
  name: 'Form',
  components: {
    LzForm
  },
  mixins: [FormHelper],
  data() {
    return {
      form: {
        slug: '',
        name: '',
        permissions: [],
      },
      isCheck: true, // 在显示复选框的情况下，是否严格的遵循父子不互相关联的做法，默认为 false
      checked: false,
      errors: {},
      allPermissionIdList: [],
      permissionsList: [],
      loading: true,
      defaultProps: {
        children: 'children',
        label: 'name'
      }
    }
  },
  methods: {
    async getData() {
      let data
      if (this.editMode) {
        ({data} = await editAdminRole(this.resourceId))
        this.fillForm(data.role)
      } else {
        ({data} = await createAdminRole())
      }

      this.allPermissionIdList = data.permissionsList.map(i => i.id);
      this.permissionsList = data.permissionsList;
      this.$refs.tree.setCheckedKeys(data.currPermissionsIdList);
      this.isCheck = false;

      this.loading = false;
    },
    async onSubmit() {
      this.form.permissions = this.$refs.tree.getCheckedNodes(false, true).map(i => i.id);
      if (this.editMode) {
        await updateAdminRole(this.resourceId, this.form)
      } else {
        await storeAdminRole(this.form)
      }
    },
    selectAllOrCancel(checked){
      if (checked) {
        this.$refs.tree.setCheckedKeys(this.allPermissionIdList);
      } else {
        this.$refs.tree.setCheckedKeys([]);
      }
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .el-transfer-panel__body {
    height: 300px;
  }

  .el-transfer-panel__list.is-filterable {
    height: 249px;
  }
}
</style>
